@if (games().length > 0) {
  <div class="or-d-flex or-justify-content-between or-align-items-center or-mb-8-px or-px-20-px">
    <div class="or-head-md">Ostatnie gierki</div>
    <div class="or-d-flex or-align-items-center">
      <button
        type="button"
        (click)="scrollPrev()"
        [disabled]="!canScrollLeft()"
        class="carousel-arrow or-mr-8-px or-d-flex or-align-items-center or-justify-content-center or-bg-white border-radius-4"
        [class.carousel-arrow-disabled]="!canScrollLeft()">
        <img src="assets/icons/chevron-up.svg" class="or-rotate-270 or-size-12-px" />
      </button>
      <button
        type="button"
        (click)="scrollNext()"
        [disabled]="!canScrollRight()"
        class="carousel-arrow or-d-flex or-align-items-center or-justify-content-center or-bg-white border-radius-4"
        [class.carousel-arrow-disabled]="!canScrollRight()">
        <img src="assets/icons/chevron-up.svg" class="or-rotate-90 or-size-12-px" />
      </button>
    </div>
  </div>
  <div #carouselRef (scroll)="onCarouselScroll()" class="or-d-flex overflow-x-auto games-carousel">
    @for (game of games(); track game.gameId) {
      <div class="game-carousel-item or-flex-shrink-0 or-px-20-px">
        <lib-game-card-v2
          [game]="game"
          [showHostDetails]="true"
          [showBottomDetails]="false"
          [redirectType]="redirectType"
          [marginsEnabled]="false"></lib-game-card-v2>
      </div>
    }
  </div>
}
